import EmptyState from '@components/v2/ui/EmptyState/EmptyState';
import EmptyStateWrapper from '@components/v2/ui/EmptyState/EmptyStateWrapper';
import GenericListIllustration from '@components/v2/ui/EmptyState/svg/GenericListIllustration';
import useSearchParams from '../../../hooks/useSearchParams';
import LangEnum from '../../../lang/LangEnum';
import { getNumberOfSelectedFilters } from '../../../lib/FilterLib';
import { MY_NETWORK_EXPLORE_FILTERS_KEYS } from '../myNetworkFilters.utils';

export interface MyNetworkListEmptyStateProps {
  title: LangEnum;
  description: LangEnum;
}

const MyNetworkListEmptyState = ({ title, description }: MyNetworkListEmptyStateProps) => {
  const { searchParams } = useSearchParams();
  const hasActiveFilters =
    getNumberOfSelectedFilters(searchParams, MY_NETWORK_EXPLORE_FILTERS_KEYS) > 0;

  if (hasActiveFilters) {
    return (
      <EmptyStateWrapper>
        <EmptyState
          title={{ text: LangEnum.GLOBAL_LIST_NO_RESULTS_TITLE }}
          description={{ text: LangEnum.GLOBAL_LIST_NO_RESULTS_DESCRIPTION }}
        />
      </EmptyStateWrapper>
    );
  }

  return (
    <EmptyStateWrapper>
      <EmptyState
        title={{ text: title }}
        description={{ text: description }}
        illustration={<GenericListIllustration />}
      />
    </EmptyStateWrapper>
  );
};

export default MyNetworkListEmptyState;
